import React from 'react';
import { ArrowDown } from 'lucide-react';
import { heroImage } from '../data/mock';

const HeroSection = () => {
  const scrollToAbout = () => {
    const aboutSection = document.querySelector('#about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Leather crafting workspace"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#3D3D3D]/70 via-[#3D3D3D]/50 to-[#3D3D3D]/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-center">
        {/* Decorative Line */}
        <div className="w-16 h-[1px] bg-[#C4B5A4] mx-auto mb-8 opacity-60" />

        {/* Main Heading */}
        <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light text-[#FAF8F5] leading-tight mb-6 tracking-wide">
          Divyanka Karmakar
        </h1>

        {/* Subtitle */}
        <p className="font-playfair text-xl md:text-2xl lg:text-3xl text-[#C4B5A4] italic mb-8">
          Bespoke Leather Design & Brand Consultancy
        </p>

        {/* Description */}
        <p className="font-inter text-sm md:text-base text-[#E8E2DB] max-w-2xl mx-auto mb-4 leading-relaxed tracking-wide">
          Bridging technical craftsmanship with global trend forecasting.
        </p>

        {/* Credential Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 border border-[#C4B5A4]/40 bg-[#C4B5A4]/10 backdrop-blur-sm rounded-sm">
          <span className="font-inter text-xs tracking-[0.2em] uppercase text-[#E8E2DB]">
            NIFT Alumna
          </span>
        </div>

        {/* Decorative Line */}
        <div className="w-16 h-[1px] bg-[#C4B5A4] mx-auto mt-12 opacity-60" />
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToAbout}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 text-[#C4B5A4] hover:text-[#FAF8F5] transition-colors duration-300 animate-bounce"
        aria-label="Scroll to about section"
      >
        <ArrowDown size={28} strokeWidth={1} />
      </button>

      {/* Side Text */}
      <div className="hidden lg:block absolute left-8 top-1/2 -translate-y-1/2 -rotate-90 origin-center">
        <span className="font-inter text-xs tracking-[0.3em] uppercase text-[#C4B5A4]/60">
          Leather Accessories Designer
        </span>
      </div>

      <div className="hidden lg:block absolute right-8 top-1/2 -translate-y-1/2 rotate-90 origin-center">
        <span className="font-inter text-xs tracking-[0.3em] uppercase text-[#C4B5A4]/60">
          Strategy Consultant
        </span>
      </div>
    </section>
  );
};

export default HeroSection;
